import { computed } from 'vue';
import useMeta from '@modules/discovery/composables/useMeta';
import useGoogleAdInline3Experiment from './useGoogleAdInline3Experiment';
import {
  addGoogleAdOnIngridTopBanner,
  addGoogleAdOnIngridMidBanner,
  addGoogleAdOnIngridBottomBanner,
  addBrandShowcasePlaceholder,
} from '../utils';
import { useNoOfProductsPerRow } from './useNoOfProductsPerRow';
import { ComputedRef, IProduct, IBanner } from '../types/sortable-grid.definitions';// eslint-disable-line no-unused-vars

/**
 *
 * @param {ComputedRef<{product:IProduct}[]>} itemsRef
 * @returns {ComputedRef<IBanner[]>}
 */
export default function useBanners(itemsRef) {
  const meta = useMeta();

  const isPhone = computed(() => meta?.value?.context?.deviceType === 'PHONE' ?? false);
  const properties = computed(() => meta?.value?.properties ?? {});
  const pageType = computed(() => meta?.value?.pageType ?? {});
  const isUSA = computed(() => meta?.value?.context?.regionCode === 'US' ?? false);
  const isWeddingRegistry = computed(() => meta?.value?.context?.shoppingMode === 'WEDDING_REGISTRY' ?? false);

  const isBrowseOrSearch = computed(() => {
    const { browse: isBrowse, search: isSearch } = pageType.value;
    const { siteMonBrandShowcaseEnabled } = properties.value;

    return siteMonBrandShowcaseEnabled && (isBrowse || isSearch);
  });

  const noOfProdsPerRow = useNoOfProductsPerRow();

  return computed(() => {
    let banners = itemsRef.value;
    const shouldAddGoogleAdBanners = isUSA.value;
    const productsPerRow = noOfProdsPerRow.value;
    const shouldAddBrandShowcase = isBrowseOrSearch.value && isUSA.value && !isWeddingRegistry.value;
    /* istanbul ignore else */
    if (banners && shouldAddGoogleAdBanners) {
      banners = addGoogleAdOnIngridTopBanner(banners, productsPerRow);
      banners = addGoogleAdOnIngridMidBanner(banners, productsPerRow);

      const { isGoogleAdInline3ExperimentEnabled } = useGoogleAdInline3Experiment();
      if (isGoogleAdInline3ExperimentEnabled.value) {
        banners = addGoogleAdOnIngridBottomBanner(banners, productsPerRow);
      } else if (shouldAddBrandShowcase) {
        banners = addBrandShowcasePlaceholder(banners, productsPerRow, isPhone);
      }
    }

    return banners || [];
  });
}
